import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'removeEnter'
})
export class RemoveEnterPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (args[0] === true) {
      return value?.replace(/\s/g, '') ?? '';
    } else {
    return value?.replace(/\n/g, '') ?? '';
    }
  }

}
